import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { STATE__workspace } from '../STATE__workspace';

interface Payload {
  entity_id: string;
  entity_type: string;
}

export const local_workspace_child_entity_child_viewer_delete_by_entity_data = (payload: Payload[]): PayloadAction<Payload[]> => ({
  type: ENUM__redux_action.WORKSPACE_CHILD_ENTITY_VIEWER_DELETE_BY_ENTITY_DATA,
  payload,
});

export const init_local_workspace_child_entity_child_viewer_delete_by_entity_data = (state: STATE__workspace, action: PayloadAction<Payload[]>) => {
  if (action.payload.is_empty()) return;

  for (let entity_data of action.payload) {
    for (let visitor of state.child_entity_viewers_map.values()) {
      if (visitor.entity_id != entity_data.entity_id || visitor.entity_type != entity_data.entity_type) continue;

      state.child_entity_viewers_map.delete(visitor.get_viewer_id());
    }
  }

  //refresh map to trigger re-render
  state.child_entity_viewers_map = new Map(state.child_entity_viewers_map);
};
